import { render, staticRenderFns } from "./AnnotationSuggestionCrop.vue?vue&type=template&id=1fbb8ed4&scoped=true"
import script from "./AnnotationSuggestionCrop.vue?vue&type=script&lang=js"
export * from "./AnnotationSuggestionCrop.vue?vue&type=script&lang=js"
import style0 from "./AnnotationSuggestionCrop.vue?vue&type=style&index=0&id=1fbb8ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb8ed4",
  null
  
)

export default component.exports